module.exports = __webpack_public_path__ + "static/media/shopify.e92b51c2.svg";